import React from "react"
import { Outlet } from "react-router-dom"
import styled from "styled-components"
import TopMenu from "../components/TopMenu"

const NewWrappper = styled.div`
  display: flex;
  width: 1920px;
  height: 100%;
  padding: 48px;
  flex-direction: column;
  align-items: flex-start;
  gap: 88px;
  background: #ecedf0;
  position: relative; /* 자식 요소 기준 */
  z-index: 0; /* 기본 레이어 */
`

const NewBackGround = styled.div`
  width: calc(1920px + 96px);
  height: 296px;
  /* background: var(--primary100, #0d1640); */
  background: linear-gradient(270deg, #0fcfd1 0%, #497ef5 100%);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; /* 가장 아래 배경 */
`

const NewHeader = styled.div`
  display: flex;
  height: 40px;
  min-width: 1400px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  position: relative;
  z-index: 3; /* 헤더가 가장 위에 표시되도록 설정 */
`

const NewBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  position: relative; /* 포지션 명시 */
  z-index: 999; /* 배경 위에 콘텐츠가 표시되도록 설정 */
`

const Layout = () => {
  return (
    <NewWrappper>
      <NewBackGround />
      <NewHeader>
        <TopMenu />
      </NewHeader>
      <NewBody>
        <Outlet />
      </NewBody>
    </NewWrappper>
  )
}

export default Layout
